<template>
  <div v-if="showEvolutionConfirmationMenu">
    Are you sure you want to evolve your {{ name }}?

    <br>
    <br>

    <div>

      <div style="width: 75%;">
      Your moves will be:
        <br>
      <button v-if="choosenEvolutionReroll"
              class="btn battle-btn col-4 ml-auto mr-auto battle-move-btn"
              style="opacity: 0.3;"
      >

        <img
            :src="`${imageUri}static/twitchextension/img/balls/empty_disc.svg`"
            class="img-fluid pokeinfo-footer__caught-using-ball"
            alt="ball"
        />

        Rerolled
        <br/>

      </button>


      <button v-else
              class="btn battle-btn col-4 ml-auto mr-auto battle-move-btn"
              style="opacity: 0.3;"
      >

        <div>
          🔒
        </div>

        Kept
        <br/>
      </button>

      </div>

      <br>

      <button
          class="btn battle-btn col-4 ml-auto mr-auto battle-move-btn"
          style="opacity: 0.9;margin:auto;"
          @click="confirmEvolution();$emit('evolution-confirmed', choosenEvolutionPokedexID, choosenEvolutionReroll, id);"
      >

        <img
            :src="`${imageUri}static/pokedex/png-sprites/pokemon/${choosenEvolutionPokedexID}.png`"
            style="filter: grayscale(100%) brightness(30%)"
            class="img-fluid pokeinfo-footer__caught-using-ball"
            alt="ball"
        />

        Confirm
        <br/>
      </button>
    </div>
  </div>

  <div v-if="displayChooseEvolutionMenu && !showEvolutionConfirmationMenu">
    <h4>
      Do you want to reroll the moves?
    </h4>


    <div
        class="row"
        v-if="moves.length === 4"
        style="border-bottom: 1px solid #dee2e6"
    >
      <button
          class="btn battle-btn col-5 ml-auto mr-auto battle-move-btn"
          style="opacity: 0.3" disabled
      >
        <div
            class="battle-move-btn__type"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  moves[0].type +
                  '.svg') +
                ')',
            }"
        ></div>

        {{ moves[0].name }}
        <br/>
        <span style="color: white">
            {{ moves[0].pp }} /
            {{ moves[0].max_pp }}</span
        >
      </button>

      <button
          class="btn battle-btn col-5 mr-auto battle-move-btn"
          style="opacity: 0.3" disabled
      >
        <div
            class="battle-move-btn__type"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  moves[1].type +
                  '.svg') +
                ')',
            }"
        ></div>

        {{ moves[1].name }}
        <br/>
        <span style="color: white">
            {{ moves[1].pp }} /
            {{ moves[1].max_pp }}</span
        >
      </button>
      <button
          class="btn battle-btn col-5 ml-auto mr-auto battle-move-btn"
          style="opacity: 0.3" disabled
      >
        <div
            class="battle-move-btn__type"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  moves[2].type +
                  '.svg') +
                ')',
            }"
        ></div>

        {{ moves[2].name }}
        <br/>
        <span style="color: white">
            {{ moves[2].pp }} /
            {{ moves[2].max_pp }}</span
        >
      </button>
      <button
          class="btn battle-btn col-5 mr-auto battle-move-btn"
          style="opacity: 0.3" disabled
      >
        <div
            class="battle-move-btn__type"
            :style="{
              backgroundImage:
                'url(' +
                require('@/assets/img/type-icons/' +
                  moves[3].type +
                  '.svg') +
                ')',
            }"
        ></div>

        {{ moves[3].name }}
        <br/>
        <span style="color: white">
            {{ moves[3].pp }} /
            {{ moves[3].max_pp }}</span
        >
      </button>
    </div>
    <div v-else>{{ translation.pokemonList.movesNotFound }}!</div>


    <br>
    <br>
    <div style="display: flex; justify-content: center">

      <button
          class="btn battle-btn col-4 ml-auto mr-auto battle-move-btn"
          style="opacity: 0.9;"
          @click="chooseReroll(true)"
      >

        <img
            :src="`${imageUri}static/twitchextension/img/balls/empty_disc.svg`"
            class="img-fluid pokeinfo-footer__caught-using-ball"
            alt="ball"
        />

        REROLL
        <br/>

      </button>


      <button
          class="btn battle-btn col-4 ml-auto mr-auto battle-move-btn"
          style="opacity: 0.9;"
          @click="chooseReroll(false)"
      >

        <div>
          🔒
        </div>
        <!--        <img-->
        <!--            :src="`${imageUri}static/pokedex/png-sprites/pokemon/poke_ball.svg`"-->
        <!--            style="filter: grayscale(100%) brightness(30%)"-->
        <!--            class="img-fluid pokeinfo-footer__caught-using-ball"-->
        <!--            alt="ball"-->
        <!--        />-->

        KEEP
        <br/>
      </button>
    </div>


  </div>

  <div v-if="displayChooseEvolutionIntoMenu">

    <div>


      <div v-for="pokemon in evolvesInto" :key="pokemon">
        <div style="display: flex;align-items: center;justify-content: center;">
          <div>
            <button
                class="btn battle-btn battle-move-btn evolution-button" style="margin-bottom: 0px;"
                :disabled="canPressEvolve(evolutionData[pokemon.pokemon])"
                @click="chooseEvolution(pokemon.pokemon)"
            >

              <img
                  :src="`${imageUri}static/pokedex/png-sprites/pokemon/${pokemon.pokemon}.png`"
                  style="filter: grayscale(100%) brightness(30%);max-width: 64px;"
                  class="img-fluid"
                  alt="ball"
              />

              <br>
              {{ pokemon.name }}
              <br/>
            </button>
          </div>

          <div style="width: 60%;margin:8px;">
            <div v-for="requirement in evolutionData[pokemon.pokemon]" :key="requirement">
              <div v-if="requirement.fulfill === true">
                ✅{{ requirement.req }}
              </div>
              <div v-else style="color: red;">
                ❌{{ requirement.req }}
              </div>
            </div>

          </div>
          <br>
          <br>
        </div>
        <br>
      </div>
    </div>
  </div>

</template>

<script>
import {imageUri} from "../../utils/settings";
import {ref} from "@vue/reactivity";
import {onMounted} from "@vue/runtime-core";
import {translation} from "@/utils/translations";
import {startLoadingProcess, stopLoadingProcess} from "../../components/LoadingOverlay/loadingOverlayControl";

export default {
  name: "Evolution",
  props: {
    id: Number,
    name: String,
    evolvesInto: Array,
    evolutionData: Object,
    moves: Array
  },
  emits: ["evolution-confirmed"],
  setup() {
    const choosenEvolutionPokedexID = ref(0);
    const choosenEvolutionReroll = ref(false);

    const displayChooseEvolutionMenu = ref(false)
    const displayChooseEvolutionIntoMenu = ref(false)
    const showEvolutionConfirmationMenu = ref(false);

    const confirmEvolution = async () => {
      startLoadingProcess()
      showEvolutionConfirmationMenu.value = false;
      stopLoadingProcess()
    }

    const chooseReroll = async (reroll) => {
      choosenEvolutionReroll.value = reroll
      showEvolutionConfirmationMenu.value = true;
      displayChooseEvolutionMenu.value = false;
    }

    function canPressEvolve (requirements) {
      for (let i = 0; i < requirements.length; i++) {
        if (requirements[i].fulfill === false) {
          return true
        }
      }
      return false
    }

    const chooseEvolution = async (pokedexID) => {
      console.log(pokedexID);
      choosenEvolutionPokedexID.value = pokedexID
      displayChooseEvolutionMenu.value = true;
      displayChooseEvolutionIntoMenu.value = false;
    }

    onMounted(() => {
      displayChooseEvolutionIntoMenu.value = true;
    });

    return {
      imageUri,
      displayChooseEvolutionMenu,
      displayChooseEvolutionIntoMenu,
      choosenEvolutionPokedexID,
      chooseEvolution,
      translation,
      showEvolutionConfirmationMenu,
      choosenEvolutionReroll,
      chooseReroll,
      confirmEvolution,
      canPressEvolve
    }
  }
}
</script>

<style lang="scss">
.battle-btn {
  background: linear-gradient(to right, rgb(203, 45, 62), rgb(239, 71, 58));
  color: white;
  border: none;
  transition: all 500ms;
}

.battle-move-btn {
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 10px;
}

.evolution-button {
  opacity:  0.9;

  &:disabled {
    opacity: 0.2;
  }
}

.battle-move-btn__type {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 0;
  right: 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.7;
  z-index: -5;
}
</style>